import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ChipsInput from "../../../components/FormComponents/ChipsInput";
import MultiSelectBox from "../../../components/FormComponents/MultiSelectBox";
import { useAxiosContext } from "../../../context/AxiosContext";
import Label from "../../../components/FormComponents/Label";

const AppUserFilter = ({
  value = {
    designations: [],
    groups: []
  },
  onChange
}) => {
  const [allGroups, setAllGroups] = useState([]);
  const [selectedGroupsData, setSelectedGroupsData] = useState([]);
  const { axiosInstance, handleError } = useAxiosContext();
  const { orgId } = useParams();

  const callbackfunction = (data) => {
    const selectedDataOfId = data.map((group) => group.id);
    onChange({
      ...value,
      groups: selectedDataOfId
    });
    setSelectedGroupsData([...data]);
  };

  const handleChangeDesignation = (newDesignations) => {
    onChange({
      ...value,
      designations: newDesignations
    });
  };

  useEffect(() => {
    const fetchAllGroup = async () => {
      try {
        const { data } = await axiosInstance.get(`/user-service/groups/org/${orgId}`);
        setAllGroups(data);
      } catch (error) {
        handleError(error);
      }
    };
    fetchAllGroup();
  }, [axiosInstance, handleError, orgId]);

  useEffect(() => {
    const groupIds = (value.groups || []).map((g) => (typeof g === "object" && g !== null ? g.id : g));
    const selectedGroups = allGroups.filter((group) => groupIds.includes(group.id));
    setSelectedGroupsData(selectedGroups);
  }, [value.groups, allGroups]);

  return (
    <div className="builder_form form_data_action_wrapper">
      <Label className="form_appuser_filter_tag">Filters</Label>
      <MultiSelectBox
        options={allGroups}
        selectedData={selectedGroupsData}
        onChange={callbackfunction}
        label="Allowed groups"
      />
      <ChipsInput label="Enter Designation" inputArray={value.designations || []} onChange={handleChangeDesignation} />
    </div>
  );
};

export default AppUserFilter;
